







import { Component, Prop, Vue } from "vue-property-decorator";

@Component({})
export default class SubTitle extends Vue {
  @Prop(String) title?: string
  @Prop({ default: "normal" }) size?: string
}
